import { TextInput } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { useEffect, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";

import { type ITankPlan } from "../../components/pages/Settings/YachtSetUp/TankPlans/tankPlans.model";
import { useGetApi } from "../../hooks";
import { oilrec1Data, oilrec2Data } from "../../mock/selectOptions";
import { Flex } from "../../styled";

interface Props {
  id: string;
  unit: string;
  value:
    | {
        key?: string;
        value?: string | { key: string };
        data?: { tankid: string; tankName: string };
      }
    | string;
  insertedTankName?: string;
}

const ORBTankSelect = ({
  id,
  unit,
  value: defaultValue,
  // insertedTankName,
}: Props) => {
  const { control, setValue } = useFormContext();
  const parsedValue = useMemo(() => {
    if (typeof defaultValue === "object") {
      return {
        value: {
          key:
            defaultValue?.key ??
            ("value" in defaultValue && typeof defaultValue.value === "object"
              ? defaultValue?.value?.key
              : ""),
        },
        data: {
          tankid: defaultValue.data?.tankid ?? "",
          // tankName: insertedTankName ?? defaultValue.data?.tankName ?? "",
          tankName: defaultValue.data?.tankName ?? "",
        },
      };
    }
    return {
      value: { key: defaultValue },
      data: {
        tankid: "",
        // tankName: insertedTankName ?? "",
        tankName: "",
      },
    };
  }, [defaultValue]);

  // useEffect(() => {
  //   if (insertedTankName) {
  //     setValue(`${id}.data`, {
  //       tankid: "",
  //       tankName: insertedTankName,
  //     });
  //   }
  // }, [insertedTankName]);

  const {
    field: { value: selectedType },
  } = useController({
    name: `${id}.value.key`,
    control,
    defaultValue: parsedValue.value.key,
  });

  const {
    field: { value: selectedTank },
  } = useController({
    name: `${id}.data.tankid`,
    control,
    defaultValue: parsedValue.data.tankid,
  });

  const {
    field: { value: selectedTankName },
  } = useController({
    name: `${id}.data.tankName`,
    control,
    defaultValue: parsedValue.data.tankName,
  });

  const { data: tanks, refetch } = useGetApi<{ list: ITankPlan[] }>({
    request: "get-tanks",
    body: { params: { orbtype: selectedType } },
    fetchOnInit: false,
  });

  useEffect(() => {
    if (selectedType) void refetch();
  }, [selectedType, refetch]);

  const typeList = unit === "oilrec1" ? oilrec1Data : oilrec2Data;
  const parsedTanks = useMemo(() => {
    const parsed =
      tanks?.list?.map((tank: any) => ({
        label: tank.name,
        value: tank.tankid,
      })) ?? [];
    if (
      defaultValue &&
      typeof defaultValue === "object" &&
      defaultValue.data?.tankName &&
      !parsed.some(tank => tank.value === defaultValue?.data?.tankid)
    ) {
      parsed.push({
        label: defaultValue?.data?.tankName,
        value: defaultValue?.data?.tankid,
      });
    }
    return parsed;
  }, [tanks]);

  const handleTypeChange = (type: any) => {
    setValue(`${id}.value`, {
      key: type,
      value: typeList[type],
    });
    setValue(`${id}.data`, {
      tankid: "",
      tankName: "",
    });
  };

  const handleTankChange = (tank: string) => {
    setValue(`${id}.data`, {
      tankid: tank,
      tankName: parsedTanks?.find(t => t.value === tank)?.label,
    });
  };

  const handleTextTankChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(`${id}.data`, {
      tankid: "",
      tankName: e.target.value,
    });
  };
  const renderTankNameInput = () => (
    <TextInput
      placeholder="No Tanks Available"
      value={selectedTankName}
      onChange={handleTextTankChange}
    />
  );
  return (
    <Flex direction="column" gap={5}>
      <Select
        data={typeList}
        value={selectedType}
        onChange={handleTypeChange}
        placeholder="Select Category"
      />
      {parsedTanks && parsedTanks.length > 0 && (
        <Select
          data={parsedTanks}
          value={selectedTank}
          onChange={handleTankChange}
          placeholder={
            parsedTanks.length > 0 ? "Select Tank" : "No Tanks Available"
          }
        />
      )}
      {parsedTanks && parsedTanks.length <= 0 && renderTankNameInput()}
    </Flex>
  );
};

export default ORBTankSelect;
